import { render, staticRenderFns } from "./addMenuCatalog.vue?vue&type=template&id=5cfe1121"
import script from "./addMenuCatalog.vue?vue&type=script&lang=js"
export * from "./addMenuCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports